@if (!forgotPassword) {
  <div class="login-container"
    >
    <div class="main--logo">
      <img src="../../../../assets/img/logo.svg"/>
    </div>
    <form class="login-form" [formGroup]="formGroup"
      (submit)="submitForm()"
      >
      <div class="inputs-list">
        <!-- <label class="input-container">
        <select>
          <option>Москва</option>
          <option>Санкт-Петербург</option>
        </select>
      </label> -->
      <label class="input-container">
        <input type="text" [placeholder]="'LOGIN' | i18n" formControlName="login"/>
      </label>
      <label class="input-container">
        <input type="password" [placeholder]="'PASSWORD' | i18n" formControlName="password"/>
      </label>
    </div>
    <div class="buttons-container">
      <button type="button" class="text-btn"
        (click)="forgotPassword = true"
        >
        Забыли пароль?
      </button>
      <button type="submit" class="confirm-btn"
        [disabled]="formGroup.invalid"
      >Войти</button>
    </div>
    @if (loginErrorMessage) {
      <p class="error-text">
        {{ loginErrorMessage }}
      </p>
    }
  </form>
  <div class="user-logo">
    <!--
    TODO
    <img src="../../../../assets/img/logo_client.png"/>
    -->
  </div>
</div>
}


@if (forgotPassword) {
  <app-forgot-password
    (onCancel)="forgotPassword = false"
  ></app-forgot-password>
}